import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { statusLabel } from "@/lib/helpers";
import { getStatusSemantic } from "@/lib/statusSemantics";

export const StatusBadge = ({ status, className }) => {
  const { badge, icon: Icon } = getStatusSemantic(status);
  return (
    <Badge
      variant="outline"
      className={cn("border font-medium gap-1.5", badge, className)}
      data-testid={`status-badge-${status}`}
      aria-label={`Status: ${statusLabel(status)}`}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {statusLabel(status)}
    </Badge>
  );
};
